import { ClipLoader } from 'react-spinners';
import history from '../history';
import { Colors } from '../themes/colors';
import { Text } from './Text';
import { useNavigate } from 'react-router';

type TProps = {
  color?: string;
  isLoading?: boolean;
  url?: string;
  onClick?: () => void;
  dataCy?: string;
};

export const SkipButton = ({
  color = Colors.secondary_500,
  isLoading = false,
  url,
  onClick,
  dataCy,
}: TProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    } else if (url) {
      history.push(url);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      className="button-reset"
      style={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        width: 'fit-content',
      }}
      type="button"
      onClick={handleOnClick}
      data-cy={dataCy}
    >
      {isLoading ? (
        <ClipLoader size={24} color={color} loading={isLoading} />
      ) : (
        <Text bold color={color} fontSize={18}>
          Skip
        </Text>
      )}
    </button>
  );
};
